import { Button } from '../ui/button';
import { Link } from '@tanstack/react-router';

// Hero Component
const Hero = () => {
    return (
        <section className="bg-neutral-50 pt-8 md:pt-6 min-h-[70vh] flex items-center">
            <div className="px-4 sm:px-6 lg:px-8 flex flex-col justify-center items-center">
                <div className="grid lg:grid-cols-5 gap-12 items-center">
                    <div className="col-span-3">
                        <p className="text-primary text-[0.875rem] font-semibold mb-2 uppercase tracking-wide">
                            The Zindua Learning Management System
                        </p>
                        <h1 className="mb-6 leading-tight tracking-[0.010em]">
                            Welcome to your one-stop centre for learning, practicing, & tracking
                            progress
                        </h1>
                        <p className="text-neutral-700 mb-8">
                            Access your <span className="font-bold">course content</span>, manage
                            your <span className="font-bold">pathway progress</span>, attempt{' '}
                            <span className="font-bold">assignments and challenges</span>, and get
                            personalized support from{' '}
                            <span className="font-bold">Rukia - the AI teaching assistant</span>
                        </p>
                        <div className="flex flex-col sm:flex-row gap-4 w-full">
                            <Link
                                to="/sign-up"
                                preload="intent"
                                preloadDelay={0}
                                className="w-full sm:w-1/2"
                            >
                                <Button variant="destructive" className="w-full">
                                    Get Started
                                </Button>
                            </Link>
                            <Link
                                to="/sign-in"
                                preload="intent"
                                preloadDelay={0}
                                className="w-full sm:w-1/2"
                            >
                                <Button variant="outline" className="border-2 w-full">
                                    Login
                                </Button>
                            </Link>
                        </div>
                        <p className="mt-6 text-neutral-500">
                            Not sure where to start?{' '}
                            <Link
                                to="/available-courses"
                                preload="intent"
                                preloadDelay={0}
                                className="text-primary font-semibold hover:text-accent"
                            >
                                Discover our Free Courses
                            </Link>
                        </p>
                    </div>

                    <div className="hidden md:flex col-span-2 justify-center items-center">
                        <div className="rounded-2xl overflow-hidden">
                            <img
                                src="/cover-image.png"
                                alt="Graduate student smiling"
                                className="w-full h-auto object-cover"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
